// extracted by mini-css-extract-plugin
export var cartContainer = "_ns-4";
export var gray = "_ns-1";
export var itemContainer = "_ns-2";
export var itemDetails = "_ns-3";
export var strong = "_ns-0";